import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/shared/material.module";
import { AbwConditionalFormatingModule } from "../../@core/abw-conditional-text-formating.module";
import { KendoModule } from "../../kendo.module";
import { MultipackCommercialPlanningDesignComponent } from "./commercial-planning-design/commercial-planning-design.component";
import { MultipackCommercialPlanningFormComponent } from "./commercial-planning-form/commercial-planning-form.component";
import { MultipackCommercialPlanningResultComponent } from "./commercial-planning-result/commercial-planning-result.component";
import { DynamicMultipackCommercialPlanningComponent } from "./dynamic-commercial-planning.component";
import { MultipackCommercialPlanningService } from "./commercial-planning.service";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { AbwMultipackCustomNumberInputComponent } from "./custom-number-input/custom-number-input.component";

@NgModule({
    declarations: [
        MultipackCommercialPlanningResultComponent,
        MultipackCommercialPlanningDesignComponent,
        MultipackCommercialPlanningFormComponent, DynamicMultipackCommercialPlanningComponent,

        AbwMultipackCustomNumberInputComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        KendoModule,
        ScrollingModule,
        AbwConditionalFormatingModule,
        NgxMatSelectSearchModule,
    ],
    entryComponents: [
        DynamicMultipackCommercialPlanningComponent,
    ],
    providers: [
        MultipackCommercialPlanningService
    ]
})
export class MultipackCommercialPlanningModule {}